import {
  HYDRATED_QUERY_OPTIONS,
  latestStatisticQuery,
} from '@/lib/page-queries';
import { useQuery } from '@tanstack/react-query';
import { ApiResponse } from '../base-api';
import { StatisticEntity } from '../types/statistic.type';

export const useLatestStatistic = () => {
  return useQuery<ApiResponse<StatisticEntity>>({
    ...latestStatisticQuery(),
    ...HYDRATED_QUERY_OPTIONS,
  });
};
